import { FormControl, FormLabel } from '@chakra-ui/react';
import { id } from 'date-fns/locale';
import React, { useEffect, useMemo } from 'react';
import { RiArrowDropDownLine } from 'react-icons/ri';
import { MultiSelect } from 'react-multi-select-component';
import api from 'services/api';
import { IOption, useEvaluationSelectorStore } from 'stores/evaluationSelector';

export default function AlinhamentosSelector() {
  const loading = useEvaluationSelectorStore((state) => state.loading);
  const selectedSectors = useEvaluationSelectorStore((state) => state.selectedSectors);
  const selectedCourses = useEvaluationSelectorStore((state) => state.selectedCourses);
  const selectedCompanies = useEvaluationSelectorStore((state) => state.selectedCompanies);
  const sectors = useEvaluationSelectorStore((state) => state.sectors);
  const selectedEvaluations = useEvaluationSelectorStore((state) => state.selectedAlinhamentosEvaluations);
  const alinhamentosEvaluations = useEvaluationSelectorStore((state) => state.alinhamentosEvaluations);

  const options = useMemo(() => {
    return alinhamentosEvaluations.map((evaluation) => {
      let label = evaluation.name;
      let value;

      if (evaluation.created_at) {
        label += ` (${new Date(evaluation.created_at).toLocaleDateString()})`;
      }

      if (evaluation.evaluation_id) {
        value = evaluation.evaluation_id;
      } else {
        value = evaluation.user_id;
      }

      return {
        label,
        value,
      };
    });
  }, [alinhamentosEvaluations]);

  const selectedOptions = useMemo(() => {
    return selectedEvaluations.map((evaluation) => {
      let value;
      if (evaluation.evaluation_id) {
        value = evaluation.evaluation_id;
      } else {
        value = evaluation.user_id;
      }
      return {
        label: evaluation.name,
        value,
      };
    });
  }, [selectedEvaluations]);

  useEffect(() => {
    if (!selectedSectors?.length && !selectedCourses?.length) {
      useEvaluationSelectorStore.setState({ alinhamentosEvaluations: [], selectedAlinhamentosEvaluations: [] });
      return;
    }
    useEvaluationSelectorStore.setState({ loading: true });
    api
      .post('users/different-companies/evaluation', {
        sector_ids: selectedSectors.map((sector) => sector.id),
        course_ids: selectedCourses.map((course) => course.id),
        company_ids: selectedCompanies.map((company) => company.id),
        allSectors: sectors.length === selectedSectors.length,
        type_evaluation: '17',
      })
      .then(({ data }) => useEvaluationSelectorStore.setState({ alinhamentosEvaluations: data }))
      .catch(() =>
        useEvaluationSelectorStore.setState({ alinhamentosEvaluations: [], selectedAlinhamentosEvaluations: [] }),
      )
      .finally(() => useEvaluationSelectorStore.setState({ loading: false }));
  }, [selectedSectors, selectedCourses, id]);

  return (
    <FormControl w="18.75rem">
      <FormLabel fontSize="0.75rem">Representante</FormLabel>
      <MultiSelect
        disabled={loading}
        isLoading={loading}
        options={options}
        value={selectedOptions}
        hasSelectAll={false}
        onChange={(e: IOption[]) => {
          const last = e[e.length - 1];
          if (!last) return useEvaluationSelectorStore.setState({ selectedAlinhamentosEvaluations: [] });
          const found = alinhamentosEvaluations.find((ev) => ev.evaluation_id === last.value || ev.user_id === last.value);
          if (!found) return useEvaluationSelectorStore.setState({ selectedAlinhamentosEvaluations: [] });
          useEvaluationSelectorStore.setState({ selectedAlinhamentosEvaluations: [found] });
        }}
        labelledBy="Select"
        overrideStrings={{
          allItemsAreSelected: 'Todos Selecionados',
          clearSearch: 'Limpar',
          clearSelected: 'Limpar',
          noOptions: 'Sem opções',
          search: 'Procurar',
          selectAll: 'Selecionar Todos',
          selectAllFiltered: 'Selecionar Todos (Filtrado)',
          selectSomeItems: 'Colaboradores',
        }}
        ArrowRenderer={() => <RiArrowDropDownLine size="1.25rem" />}
      />
    </FormControl>
  );
}
